import { Layout } from "@/components/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AgentsTab } from "@/pages/admin/AgentsTab";
import { ManagersTab } from "@/pages/admin/ManagersTab";
import { CampaignsTab } from "@/pages/admin/CampaignsTab";
import { ReportTab } from "@/pages/admin/ReportTab";
import { LeaderboardTab } from "@/pages/admin/LeaderboardTab";
import { SecurityTab } from "@/pages/admin/SecurityTab";

const tabCls = "data-[state=active]:bg-[#0B6BCB] data-[state=active]:text-[#FFFFFF] px-4 py-2 text-sm";

export default function AdminDashboard() {
  return (
    <Layout>
      <div className="mb-6">
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight">Pannello Amministratore</h1>
        <p className="text-[#5A6B85] mt-1">Gestisci agenti, capi area, campagne e report.</p>
      </div>
      <Tabs defaultValue="agents" className="space-y-6">
        <TabsList className="bg-[#FFFFFF] border border-[#DCE7F5] h-auto p-1 flex-wrap">
          <TabsTrigger value="agents" className={tabCls} data-testid="admin-tab-agents">Agenti</TabsTrigger>
          <TabsTrigger value="managers" className={tabCls} data-testid="admin-tab-managers">Capi Area</TabsTrigger>
          <TabsTrigger value="campaigns" className={tabCls} data-testid="admin-tab-campaigns">Campagne</TabsTrigger>
          <TabsTrigger value="report" className={tabCls} data-testid="admin-tab-report">Report</TabsTrigger>
          <TabsTrigger value="leaderboard" className={tabCls} data-testid="admin-tab-leaderboard">Classifica</TabsTrigger>
          <TabsTrigger value="security" className={tabCls} data-testid="admin-tab-security">Sicurezza</TabsTrigger>
        </TabsList>
        <TabsContent value="agents"><AgentsTab /></TabsContent>
        <TabsContent value="managers"><ManagersTab /></TabsContent>
        <TabsContent value="campaigns"><CampaignsTab /></TabsContent>
        <TabsContent value="report"><ReportTab /></TabsContent>
        <TabsContent value="leaderboard"><LeaderboardTab /></TabsContent>
        <TabsContent value="security"><SecurityTab /></TabsContent>
      </Tabs>
    </Layout>
  );
}
